module.exports = __webpack_public_path__ + "seccionbordo.97b12c56f1ab54931beb.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/assets/img/seccionbordo.png
// module id = ../../../../../src/assets/img/seccionbordo.png
// module chunks = 17